import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { Checkbox, checkboxProptypes } from '@wf-common/atoms'

import styles from './tag-dropdown.module.css'

const propTypes = {
    checkboxProps: PropTypes.shape(checkboxProptypes),
    className: PropTypes.string,
    labelIcon: PropTypes.string,
    onPreselect: PropTypes.func,
    selection: PropTypes.array,
    value: PropTypes.array.isRequired
}

const defaultProps = {
    onPreselect: () => {},
    selection: []
}

/**
 * Adds bulk-selection checkboxes to the tag dropdown. To be used within TagDropdown component only.
 *
 * Usage:
 * <TagDropdown>
 *     <Preselector values={[ 0, 1, 2 ]}>First three items</Preselector>
 *     <Checkbox value={0}>A</Checkbox>
 *     <Checkbox value={1}>B</Checkbox>
 *     <Checkbox value={2}>C</Checkbox>
 *     <Checkbox value={3}>D</Checkbox>
 *     <Checkbox value={4}>E</Checkbox>
 *     ...
 * </TagDropdown>
 *
 * @param {Object[]} [value] - array of values that the preselector should (un)select.
 * @param {T3Checkbox} [checkboxProps={}] - The checkbox properties which are passed through.
 * @param {Object[]} [selection=[]] - array of currently selected values. Auto-populated by TagDropdown.
 * @param {Function} [onPreselect=()=>{}] - callback when the checkbox is cliked. Auto-populated by TagDropdown.
 * @param {string} [className=null] - custom styling through additional css classes
 */
const Preselector = ({ checkboxProps = {}, children, className, onPreselect, selection, value }) => {
    // If any of the values defined by the preselector is not in the current selection
    // then the checkbox shouldn't be checked.

    const checked = value.every(i => selection.indexOf(i) >= 0)
    return (
        <Checkbox
            checked={checked}
            className={cx(styles['tag-dropdown-list-item'], styles['preselector'], className)}
            onChange={(event, checked) => onPreselect(value, checked)}
            selectionProp="checked"
            {...checkboxProps}
            labelClassName={cx(styles['preselector-label'], checkboxProps.labelClassName)}
        >
            {children}
        </Checkbox>
    )
}

Preselector.propTypes = propTypes
Preselector.defaultProps = defaultProps

export default Preselector
